import { useLoading, useGeneral } from '@/store'
import {
  InfoResponse,
  HomeResponse,
  AnniversaryResponse,
  IpResponse,
  WorkshopResponse,
  ComicResponse,
} from '@/services/responseType'

type ApiResult = InfoResponse | HomeResponse | AnniversaryResponse | IpResponse | WorkshopResponse | ComicResponse;

const toastList: string[] = [
  'TOAST_EVENTOVER',
  'TOAST_EVENT_CLOSED_AWHILE',
  'TOAST_EVENT_END',
  'TOAST_EVENT_NOTOPEN',
  'TOAST_SERVER_TIMEOUT',
  'TOAST_WRONG_REGION'
];

async function useApi<T extends ApiResult>(asyncFunc: () => Promise<T>) {
  const { updateLoading } = useLoading();
  const { handleToast, handleError } = useGeneral();
  try {
    updateLoading(true);
    const response = await asyncFunc();

    if (response.status === 'error') {
      if (toastList.includes(response.msg)) {
        // toast cannot closed
        handleError(response.msg);
      }
      else handleToast(true, response.msg, false)
    }
    return response;
  } catch (error: any) {
    handleError('NETWORK CONNECTION ERROR, PLEASE TRY AGAIN LATER');
  } finally {
    updateLoading(false);
  }
  return null;
}

export default useApi;
